import ROOTURL from "./ROOTURL"
import axios from "axios"

export const AddNewsletter = (data) =>
  axios.post(`${ROOTURL}/requestnewsletter`, data)
